import { useState } from 'react';
import { useSafeLayoutEffect } from '@hooks/useSafeLayoutEffect';

// Looks for an element in the DOM with the ID layout to use as the boundary for hover cards / tooltips etc if present
export const useGetLayoutContainer = () => {
  const [layoutElement, setLayoutElement] = useState<HTMLElement | null>(null);
  useSafeLayoutEffect(() => {
    setLayoutElement(window.document.getElementById('layout'));
  }, []);
  return layoutElement;
};
